import { createSlice } from "@reduxjs/toolkit";
import {
    fetchEnrollStudentsTableColumnNames,
    fetchAllEnrollStudents,
    createEnrollStudents,
    updateEnrollStudents,
    deleteEnrollStudents,
    updateEnrollStudentsCoursePayment
} from "./thunk";

const enrollStudentsSlice = createSlice({
  name: "EnrollStudents",
  initialState: {
    enrollStudents: [],
    tableColumnNames: [],
    loading: false,
    headerload: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder

      // Fetch Enroll Students Table Column Names
      .addCase(fetchEnrollStudentsTableColumnNames.pending, (state) => {
        state.headerload = true;
        state.error = null;
      })
      .addCase(fetchEnrollStudentsTableColumnNames.fulfilled, (state, action) => {
        state.headerload = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchEnrollStudentsTableColumnNames.rejected, (state, action) => {
        state.headerload = false;
        state.error = action.payload;
      })

      // Get All Enroll Students
      .addCase(fetchAllEnrollStudents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllEnrollStudents.fulfilled, (state, action) => {
        state.loading = false;
        state.enrollStudents = action.payload;
      })
      .addCase(fetchAllEnrollStudents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Enroll Students
      .addCase(createEnrollStudents.pending, (state) => {
        state.error = null;
      })
      .addCase(createEnrollStudents.fulfilled, (state, action) => {
        state.enrollStudents = [action.payload.data[0], ...state.enrollStudents.filter((item) => item.UserId !== action.payload.data[0].UserId)];
      })
      .addCase(createEnrollStudents.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Update Enroll Students
      .addCase(updateEnrollStudents.pending, (state) => {
        state.error = null;
      })
      .addCase(updateEnrollStudents.fulfilled, (state, action) => {
        // const index = state.enrollStudents.findIndex(
        //   (item) => item.UserId === action.payload[0].UserId
        // );

        // if (index !== -1) {
        //   state.enrollStudents[index] = action.payload[0];
        // }

        state.enrollStudents = state.enrollStudents.map((item) => item.UserId === action.payload[0].UserId ? action.payload[0] : item);
      })
      .addCase(updateEnrollStudents.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Delete Enroll Students
      .addCase(deleteEnrollStudents.pending, (state) => {
        state.error = null;
      })
      .addCase(deleteEnrollStudents.fulfilled, (state, action) => {
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.enrollStudents = state.enrollStudents.filter(
          (item) => !deletedIds.includes(item.ID)
        );

      })
      .addCase(deleteEnrollStudents.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Update Enroll Students
      .addCase(updateEnrollStudentsCoursePayment.pending, (state) => {
        state.error = null;
      })
      .addCase(updateEnrollStudentsCoursePayment.fulfilled, (state, action) => {
        const updatedStudents = action.payload[0];

        state.enrollStudents = state.enrollStudents.map((item) => item.PaymentID === updatedStudents?.PaymentID ? {
          ...item, 
          Discount: updatedStudents?.Discount, 
          PaymentStatus: updatedStudents?.PaymentStatus
        } : item);
      })
      .addCase(updateEnrollStudentsCoursePayment.rejected, (state, action) => {
        state.error = action.payload;
      })
    },
});

export default enrollStudentsSlice.reducer;
